import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationFR from './locales/fr.json';
import translationES from './locales/es.json';
import translationIT from './locales/it.json';
import translationPT from './locales/pt.json';
import translationTR from './locales/tr.json';
import translationZH from './locales/zh.json';
import translationAR from './locales/ar.json';
import translationTA from './locales/ta.json';
import translationHI from './locales/hi.json';
import translationBN from './locales/bn.json';
import translationWO from './locales/wo.json';

const resources = {
  fr: { translation: translationFR },
  en: { translation: translationEN },
  es: { translation: translationES },
  it: { translation: translationIT },
  pt: { translation: translationPT },
  tr: { translation: translationTR },
  zh: { translation: translationZH },
  ar: { translation: translationAR },
  ta: { translation: translationTA },
  hi: { translation: translationHI },
  bn: { translation: translationBN },
  wo: { translation: translationWO },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    lng: localStorage.getItem('preferred-language') || localStorage.getItem('i18nextLng') || 'fr',
    supportedLngs: ['fr', 'en', 'es', 'it', 'pt', 'tr', 'zh', 'ar', 'ta', 'hi', 'bn', 'wo'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'preferred-language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
